export function isValidEmail(email: string): boolean {
	return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
}

export function getValidSymbolForPassword(): RegExp {
	return /[-#!¡$@£%^&*()_+|~=`´{}\[\]:";'<>?¿,.\/·\\ºª¨çÇ ]/
}
